import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';

const classPrefix = 'result-supervision';
const dataPrefix = 'data-result-supervision';

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector(`[${dataPrefix}]`);
    console.log('resultSupervision: container =', container);
    if (container) resultSupervision(container);
});

function resultSupervision(container) {
    const thanksTemplate = container.querySelector(`template[${dataPrefix}-thanks-template]`) || document.querySelector(`template[${dataPrefix}-thanks-template]`);
    const ratingContainer = container.querySelector(`[${dataPrefix}-rating-container]`) || container;
    const exerciseId = ratingContainer?.getAttribute('data-exercise-id') || null;
    const hasRated = ratingContainer?.getAttribute('data-has-rated') === '1';

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || '';

    function recordStat(watched) {
        if (!exerciseId) {
            console.warn('No exerciseId for recordStat');
            return Promise.resolve();
        }
        console.log('saveSupervisionStat', watched);
        return fetch(`/exercise/${exerciseId}/video/stat`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(csrfToken && { 'X-CSRF-TOKEN': csrfToken }),
            },
            body: JSON.stringify({
                watched,
                reachedAt: new Date().toISOString(),
            }),
        }).catch(err => console.error(err));
    }

    // --- ИНИЦИАЛИЗАЦИЯ PREVIEW/GLIGHTBOX (всегда, до проверки hasRated) ---
    const previewLinks = container.querySelectorAll('.glightbox');
    console.log('resultSupervision: found glightbox links =', previewLinks.length);

    previewLinks.forEach(el => {
        // безопасно — при повторной инициализации несколько обработчиков не критично, но можно очищать, если нужно
        console.log('attach glightbox handler to', el);
        el.addEventListener('click', e => {
            console.log('glightbox click', e.currentTarget);
            e.preventDefault();

            const href = el.dataset.videoUrl || el.getAttribute('href') || null;
            if (!href) {
                console.warn('No video URL found on element', el);
                return;
            }

            // определяем источник (youtube/vimeo/local)
            let source = 'local';
            if (/youtube\.com|youtu\.be/.test(href)) source = 'youtube';
            else if (/vimeo\.com/.test(href)) source = 'vimeo';

            // пометим открытие
            recordStat(1);

            const player = GLightbox({
                elements: [{ href, type: 'video', source }],
                autoplayVideos: true,
                openEffect: 'fade',
                closeEffect: 'fade',
            });

            player.on('slide_after_load', ({ slide }) => {
                // видео может появляться асинхронно, ищем внутри текущего слайда
                const videoEl = document.querySelector('.gslide--current video');
                if (!videoEl) return;

                let sent50 = false;
                // duration может быть 0 пока метадата не загружена
                const tryBind = () => {
                    const duration = videoEl.duration || 0;
                    if (!duration) return;
                    videoEl.addEventListener('timeupdate', () => {
                        if (sent50 || !duration) return;
                        const percent = (videoEl.currentTime / duration) * 100;
                        if (percent >= 50) {
                            sent50 = true;
                            recordStat(50);
                        }
                    });
                };

                if (videoEl.readyState >= 1) tryBind();
                else videoEl.addEventListener('loadedmetadata', tryBind, { once: true });
            });

            player.open();
        });
    });

    // --- если уже оценили — показываем благодарность и прекращаем инициализацию рейтингов (но preview уже подключён) ---
    if (hasRated) {
        console.log('resultSupervision: user has already rated — showing thanks');
        if (thanksTemplate) {
            const content = thanksTemplate.content.cloneNode(true);
            ratingContainer.innerHTML = '';
            ratingContainer.classList.add(`${classPrefix}__container--banner`);
            ratingContainer.classList.remove(`${classPrefix}__container--center`);
            ratingContainer.appendChild(content);
        }
        return; // ratings не нужны
    }

    // === блок рейтингов ===
    const ratings = container.querySelectorAll(`[${dataPrefix}-rating]`);
    const selectedValues = {};

    ratings.forEach(ratingEl => initRating(ratingEl));

    function initRating(ratingEl) {
        const key = ratingEl.getAttribute(`${dataPrefix}-rating`);
        const stars = ratingEl.querySelectorAll(`svg[${dataPrefix}-star]`);
        let selected = 0;

        stars.forEach(star => {
            const value = Number(star.getAttribute(`${dataPrefix}-star`));
            star.addEventListener('mouseover', () => update(value));
            star.addEventListener('mouseout', () => update(selected));
            star.addEventListener('click', () => {
                selected = value;
                selectedValues[key] = value;
                update(selected);
                checkAll();
            });
        });

        function update(count) {
            stars.forEach(star => {
                const idx = Number(star.getAttribute(`${dataPrefix}-star`));
                const useEl = star.querySelector('use');
                if (useEl) useEl.setAttribute('xlink:href', idx <= count ? '#star-fill' : '#star-empty');
            });
        }
        update(selected);
    }

    function checkAll() {
        const keys = Array.from(ratings).map(r => r.getAttribute(`${dataPrefix}-rating`));
        if (keys.every(k => selectedValues[k] > 0)) onAllRatingsSelected(selectedValues);
    }

    async function onAllRatingsSelected(values) {
        if (!exerciseId) return;

        ratings.forEach(rEl =>
            rEl.querySelectorAll(`svg[${dataPrefix}-star]`).forEach(st => (st.style.pointerEvents = 'none'))
        );

        const payload = {
            interest: values.interest,
            exercise: values.exercise,
            benefit: values.benefit,
        };

        try {
            const res = await fetch(`/exercise/${exerciseId}/rating/save`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(csrfToken && { 'X-CSRF-TOKEN': csrfToken }),
                },
                body: JSON.stringify(payload),
            });

            if (!res.ok) throw new Error('Network response was not ok');
            const { success } = await res.json();

            if (success && thanksTemplate) {
                container.setAttribute('data-has-rated', '1');
                const content = thanksTemplate.content.cloneNode(true);
                ratingContainer.innerHTML = '';
                ratingContainer.classList.add(`${classPrefix}__container--banner`);
                ratingContainer.classList.remove(`${classPrefix}__container--center`);
                ratingContainer.appendChild(content);
            }
        } catch (err) {
            console.error(err);
            showError('Ошибка при отправке оценки');
        }
    }

    function showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.classList.add(`${classPrefix}__error-banner`);
        errorDiv.textContent = message;
        ratingContainer.appendChild(errorDiv);
    }
}
